module.exports = "<div class=\"news devblog\">\n  <div class=\"news_header devblog_header\">\n    News id-{{itemid}}\n  </div>\n  <div class=\"news_body\">\n    <p>\n      blogitem works!\n\n      {{itemid}}\n    </p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/devblog/blogitem/blogitem.component.html
// module id = ./src/app/components/devblog/blogitem/blogitem.component.html
// module chunks = main